export const DECIMAL_MULTIPLIER = 1000000

export const TIME_TOLERANCE = 6

export const BEAMER_SELECTOR_ID = 'beamer_trigger'

export const DEFAULT_TIMEZONE = 'UTC'

export const COMMON_TEST_IDS = {
  CREATE_VIDEO_BUTTON: 'create_video_button',
}
